function pa_move_giftwrap() {
   
  //CALLED ON giftkart_script.cart.liquid line 904
	  
  gkt.$('.cart-template__footer').before(gkt.$('.gktPageWrapper'))

  //var cart_div = document.querySelector(".cart-template__footer");
  //var gkt_page = document.querySelector(".gktPageWrapper");

  console.log("pa_move_giftwrap");
  
};


//---------------------------------------------------------------------------------
document.addEventListener("DOMContentLoaded", function() {
  
  //***************************************************************************
  //CUSTOM TOGGLE in product page
  var pa_elems = document.querySelectorAll('.pa_tab_title');
  [].forEach.call( pa_elems , function(el){
      el.addEventListener("click", function() {
          el.parentElement.classList.toggle('active');
      });
  });
  
  //***************************************************************************
  //TAGS TRANSLATION
  var pa_tags_translations = [{"fr":"Ajouré","en":"Openwork"},{"fr":"Anneaux","en":"Links"},{"fr":"Argenté","en":"Silver plated"},{"fr":"Asymétrique","en":"Asymmetric"},{"fr":"Bagues double","en":"Double rings"},{"fr":"Bagues","en":"Rings"},{"fr":"Bagues d'oreille","en":"Earcuffs"},{"fr":"Bicolore","en":"Bicolor"},{"fr":"Bombé","en":"Rounded"},{"fr":"Boucles d'oreilles","en":"Earrings"},{"fr":"Bracelets","en":"Bracelet"},{"fr":"Carré","en":"Square"},{"fr":"Cercle","en":"Circle"},{"fr":"Chaines double","en":"Double chains"},{"fr":"Chaînes","en":"Chains"},{"fr":"Chevalière","en":"Signet ring"},{"fr":"Clips","en":"Clips"},{"fr":"Cœur","en":"Heart"},{"fr":"Colliers","en":"Necklaces"},{"fr":"Croisé","en":"Criss-crossed"},{"fr":"Créoles","en":"Hoop earrings"},{"fr":"Doré","en":"24k gold plated"},{"fr":"Élastique","en":"Elastic"},{"fr":"Entrelacé","en":"Interlaced"},{"fr":"Femme","en":"Women"},{"fr":"Fin","en":"Thin"},{"fr":"Gourmette","en":"Curb chain"},{"fr":"Gouttes","en":"Drop"},{"fr":"Graphique","en":"Graphic"},{"fr":"Gros","en":"Thick"},{"fr":"Géométrique","en":"Geometric"},{"fr":"Large","en":"Large"},{"fr":"Lisse","en":"Smooth"},{"fr":"Maillons rectangles","en":"Square links"},{"fr":"Maillons larges","en":"Large links"},{"fr":"Maillons ronds","en":"Round links"},{"fr":"Manchettes","en":"Cuffs"},{"fr":"Marine","en":"Marine"},{"fr":"Mini","en":"Mini"},{"fr":"Multi-chaines","en":"Multichains"},{"fr":"Médaille","en":"Pendant"},{"fr":"Nouveautés","en":"New"},{"fr":"Ovale","en":"Oval"},{"fr":"Pendentif","en":"Pendant"},{"fr":"Perles","en":"Beads"},{"fr":"Perlé","en":"Beaded"},{"fr":"Pinky ring","en":"Pinky ring"},{"fr":"Plume","en":"Feather"},{"fr":"Puce","en":"Studs"},{"fr":"Rectangles","en":"Rectangles"},{"fr":"Rectangulaire","en":"Rectangular"},{"fr":"Retro","en":"Retro"},{"fr":"Rigides","en":"Rigid"},{"fr":"Ronds","en":"Round links"},{"fr":"Sautoirs","en":"Long necklaces"},{"fr":"Strass Swarovski","en":"Swarovski rhinestones"},{"fr":"Torsadé","en":"Twisted"},{"fr":"Tressé","en":"Braided"},{"fr":"Vintage","en":"Vintage"},{"fr":"Argenté","en":"Silver plated"},{"fr":"Bagues","en":"Rings"},{"fr":"Bicolore","en":"Bicolor"},{"fr":"Bracelets","en":"Bracelets"},{"fr":"Ethniques","en":"Ethnic"},{"fr":"Rigides","en":"Rigid"},{"fr":"Chaîne","en":"Chain"},{"fr":"Colliers","en":"Necklaces"},{"fr":"Doré","en":"24k gold plated"},{"fr":"Elastique","en":"Elastic"},{"fr":"Fin","en":"Thin"},{"fr":"Flèche","en":"Arrow"},{"fr":"Gourmette","en":"Curb chain"},{"fr":"Graphique","en":"Graphic"},{"fr":"Large","en":"Large"},{"fr":"Lisse","en":"Smooth"},{"fr":"Maillons rectangles","en":"Rectangle links"},{"fr":"Maillons larges","en":"Large links"},{"fr":"Pierres","en":"Stones"},{"fr":"Plume","en":"Feather"},{"fr":"Strié","en":"Striped"},{"fr":"Tressé","en":"Braided"}];
	
  if (document.documentElement.lang !== "fr") {
  	console.log("English lang");
	
	var pa_elems = document.querySelectorAll('.collection-sidebar__group');
	[].forEach.call( pa_elems , function(el){
		//if( el.dataset.group == 'Tags' ){
			
			var pa_tags = el.querySelectorAll('.filter-item__label');
			[].forEach.call( pa_tags , function(eltag){
				var pa_tag = eltag.innerHTML.trim() ;
				let found = pa_tags_translations.find(element => element['fr'] == pa_tag);
				if(typeof( found ) !== 'undefined'){
					eltag.innerHTML = found["en"];
				}
				
			});
		//}
	});
	 
  }
  
   
  
  
  
});




  
 
  
  
 